<h1 mat-dialog-title>Contact {{data.nickOpen}} {{data.contactIdOpen}} is not verified</h1>
<div mat-dialog-content>
  <p>This communication is end-to-end encrypted. But this contact is not verified yet. To ensure security please verify.</p>
  <p>You can do it later from Contact info.</p>
</div>
<div mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="true">Verify</button>
  <button mat-button [mat-dialog-close]="false">Later</button>
</div>
